module.exports = __webpack_public_path__ + "media/BELL.de59c2fb.mp3";